import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import { CenterQuestionnaireContent } from "components/InAppQuestionnaire/InAppQuestionnaire";
import Translate from "components/Translate/Translate";
import type { FC } from "react";
import React from "react";

const ContainerFirstStep = styled.div`
  max-width: 442px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    border-radius: 1em;
    margin-bottom: 16px;
  }

  p:last-of-type {
    margin-top: 0;
    margin-bottom: 24px;
  }
`;

interface FirstStepProps {
  firstName: string;
  onContinue: () => void;
}

export const FirstStep: FC<FirstStepProps> = ({ firstName, onContinue }) => {
  return (
    <CenterQuestionnaireContent>
      <ContainerFirstStep>
        <img src="https://d3a2es9lb3nmct.cloudfront.net/img/41260de7763e60200616c32cb1e4476b09d32e90-1396x986.jpg?fit=max&w=500&h=500" />
        <h4 style={{ textAlign: "center" }}>
          <Translate
            msg="task.yourRecurringLab.questionnaire.title"
            variables={{ firstName: firstName }}
          />
        </h4>
        <p>
          <Translate msg="task.yourRecurringLab.questionnaire.description.p1" />
        </p>
        <p>
          <Translate msg="task.yourRecurringLab.questionnaire.description.p2" />
        </p>

        <Button onPress={onContinue} theme="sunrise">
          <Translate msg="continue" />
        </Button>
      </ContainerFirstStep>
    </CenterQuestionnaireContent>
  );
};

export default FirstStep;
